import styled from "styled-components";

export const ProgramVideoListStyled = styled.div`
  padding: 20rem 0;
`;
